import * as Yup from 'yup';
import { ItemDataType } from 'rsuite5/esm/@types/common';
import { SUBSCRIBE_OPTION } from '../constants';

export const optionPickerData: ItemDataType[] = [
  { label: '贵宾休息室', value: SUBSCRIBE_OPTION.LOUNGE },
  { label: '代客泊车', value: SUBSCRIBE_OPTION.PARKING },
  { label: '导购大使', value: SUBSCRIBE_OPTION.SA },
];

/**
 * 服务余量设置表单默认值
 */
export const defaultMarginInfo = {
  number: '',
  option_id: '',
  start_time: '',
  end_time: '',
  reason: '',
};

/**
 * 服务余量历史设置记录查询表单默认值
 */
export const defaultMarginRecordInfo = {
  time_range: [],
  option_id: null,
  is_delete: null,
};

/**
 * 服务余量设置表单校验
 */
export const marginSchema = Yup.object().shape(
  {
    number: Yup.string().ensure().required('请输入数量限制').matches(/^(0|[1-9]\d*)$/, '请输入正确的数量'),
    option_id: Yup.number().typeError('请选择项目').required('请选择项目'),
    start_time: Yup.string().required('请选择开始时间'),
    end_time: Yup.string().required('请选择结束时间'),
  }
);